// import React, { useRef } from 'react';
// import '../styles/Footer.css';
// import { Link } from 'react-router-dom';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faLinkedin, faInstagram, faXTwitter, faGoogle, faFacebookF } from '@fortawesome/free-brands-svg-icons';

// function Footer() {
//     const topRef = useRef(null);
//     return (
//         <div className='p-5 body-footer'>
//             <div className=" rounded-lg bg-black bg-opacity-70 gap-3 shadow-2xl bg-opacity-100 lg:grid-cols-2 grid sm:grid-cols-1 sm:flex-row ">
//                 <div className="flex justify-center items-center grid grid-cols-1 " style={{ maxWidth: "500px" }}>
//                     {/* <h2 className="font-bold text-center font-montserrat mb-5 text-lg text-white">Location</h2> */}
//                     <div className='rounded-lg ' style={{ position: 'relative', overflow: 'hidden', padding: '' }}>
//                         <iframe src="https://www.google.com/maps/embed?pb=!1m19!1m8!1m3!1d54740.695828695265!2d76.503064!3d30.962291!3m2!1i1024!2i768!4f13.1!4m8!3e0!4m0!4m5!1s0x3905542fe45e58f7%3A0x5d16c2617cfdbdb8!2sIndian%20Institute%20Of%20Technology%E2%80%93Ropar%20(IIT%E2%80%93Ropar)%2C%20Bara%20Phool%2C%20Punjab%20140001!3m2!1d30.968616899999997!2d76.473305!5e0!3m2!1sen!2sin!4v1702729445810!5m2!1sen!2sin" width="100%" height="250" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" style={{ border: '0px', marginBottom: '4%' }}></iframe>
//                     </div>
//                 </div>

//                 <div className='flex lg:flex-row sm:flex-col xs:flex-col justify-center  p-3'>
//                     <div className='lg:flex-col sm:flex-row xs:flex-row text-wrap'>
//                         <div className="" >
//                             {/* <h2 className='font-montserrat text-3xl  text-white'> Office-Address:</h2> */}
//                             <p className='mt-10 font-montserrat font-auto lg:text-lg sm:text-sm text-white lg:text-justify'>
//                                 <p className='m-2'>Technology Business Incubator Foundation</p>
//                                 <p className='m-2'>Indian Institute Of Technology, Ropar</p>
//                                 <p className='m-2'> Rupnagar - 140001,Punjab, India</p>
//                             </p>

//                         </div>
//                         <div className="lg:mt-5 p-3 hover:border-white hover:border-3 text-center">
//                             <h2 className="font-roboto  text-lg  text-white">Contact :</h2>
//                             <p className='font-montserrat text-lg text-white   '>Email: tbif@iitrpr.ac.in</p>
//                             <p className='font-montserrat text-lg text-white  '>Phone: +91-1234567890</p>
//                         </div>
//                     </div>
//                     <div>

//                         <div className='grid gap-5 ' >
//                             <h2 className="font-bold text-center font-montserrat text-lg text-emerald-400">Quick Links</h2>
//                             <div className='text-center'>
//                                 <ul className="" >
//                                     <li className="text-white font-montserrat font-bold text-sm hover:text-orange-400 p-2 hover-underline-animation">
//                                         <Link to="/" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>Home</Link>
//                                     </li>
//                                     <li className="text-white font-montserrat font-bold text-sm hover:text-orange-400 p-2 hover-underline-animation">
//                                         <Link to="/about" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>About</Link>
//                                     </li>
//                                     <li className="text-white font-montserrat font-bold text-sm hover:text-orange-400 p-2 hover-underline-animation">
//                                         <Link to="/team" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>Team</Link>
//                                     </li>
//                                 </ul>
//                                 <ul>
//                                     <li className="text-white font-montserrat font-bold text-sm hover:text-orange-400 p-2 hover-underline-animation">
//                                         <Link to="/facilities" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>Support</Link>
//                                     </li>
//                                     <li className="text-white font-montserrat font-bold text-sm hover:text-orange-400 p-2 hover-underline-animation">
//                                         <Link to="/career" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>Career</Link>
//                                     </li>
//                                     <li className="text-white font-montserrat font-bold text-sm hover:text-orange-400 p-2 hover-underline-animation">
//                                         <Link to="/contact-us" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>Contact Us</Link>
//                                     </li>

//                                     {/* <li className="text-white font-montserrat font-bold text-sm hover:text-orange-400 p-2 hover-underline-animation">Apply</li> */}

//                                 </ul>
//                             </div>
//                         </div>
//                     </div>
//                     {/* </div> */}
//                     <div className=" flex justify-around grid grid-col-1 ">
//                         {/* <div className='relative'> */}
//                         <a href='https://docs.google.com/forms/d/e/1FAIpQLSeonn6YOY2MH56wk2SP5XncP3WeR3BKUsXQopW6cstC63ZAuQ/viewform' target='_blank' className='flex justify-center items-center'>
//                             <button className='relatove bg-green-300 font-bold text-lg rounded-lg p-2  hover:shadow-xl hover:shadow-sky-300 hover:scale-110 transition transform-700 lg:mt-20' >
//                                 Incubate!
//                             </button>
//                         </a>
//                         <h2 className="sm:mb-10 xs:mb-10 xs:mt-5 font-roboto text-3xl text-center text-white transition-transform ease-in-out delay-400" >Connect with Us</h2>
//                         <div className="flex justify-between items-center gap-3 lg:mb-11 sm:mb-5 md:mb-8 xs:mb-5">
//                             <a href="https://www.linkedin.com/company/iit-ropar-technology-business-incubator-foundation?original_refe" target="_blank" rel="noopener noreferrer">
//                                 <FontAwesomeIcon className='hover:scale-110' icon={faLinkedin} size="2x" color="#0077B5" />
//                             </a>
//                             <a href="https://www.instagram.com/iitropartbif/" target="_blank" rel="noopener noreferrer">
//                                 <FontAwesomeIcon className='hover:scale-110' icon={faInstagram} size="2x" color="#E1306C" />
//                             </a>
//                             <a href="https://x.com/iitrprtbif?lang=en" target="_blank" rel="noopener noreferrer">
//                                 <FontAwesomeIcon className='hover:scale-110' icon={faXTwitter} size="2x" color="white" />
//                             </a>
//                             <a href="mailto:tbif.iitrpr.ac.in" target="_blank" rel="noopener noreferrer">
//                                 <FontAwesomeIcon className='hover:scale-110' icon={faGoogle} size="2x" color="#DB4437" />
//                             </a>
//                             <a href="https://www.facebook.com/p/IIT-Ropar-TBIF-100064188995310/" target="_blank" rel="noopener noreferrer">
//                                 <FontAwesomeIcon className='hover:scale-110' icon={faFacebookF} size="2x" color="#1877F2" />
//                             </a>
//                         </div>
//                     </div>
//                 </div>
//             </div >
//         </div>
//     )
// };

// export default Footer;
import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin, faInstagram, faXTwitter, faGoogle, faFacebookF } from '@fortawesome/free-brands-svg-icons';

export default function Footer() {
  return (
    <footer className="bg-white py-8 lg:px-6 px-8 flex justify-center">
      <div className="bg-black rounded-xl shadow-2xl max-w-7xl w-full grid grid-cols-1 lg:grid-cols-3 gap-6 p-6">

        {/* Left Column: Map */}
        <div className="w-full h-64 rounded-lg overflow-hidden">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m19!1m8!1m3!1d54740.695828695265!2d76.503064!3d30.962291!3m2!1i1024!2i768!4f13.1!4m8!3e0!4m0!4m5!1s0x3905542fe45e58f7%3A0x5d16c2617cfdbdb8!2sIndian%20Institute%20Of%20Technology%E2%80%93Ropar%20(IIT%E2%80%93Ropar)%2C%20Bara%20Phool%2C%20Punjab%20140001!3m2!1d30.968616899999997!2d76.473305!5e0!3m2!1sen!2sin!4v1702729445810!5m2!1sen!2sin"
            className="w-full h-full"
            frameBorder="0"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>

        {/* Middle Column: Address & Contact */}
        <div className="flex flex-col text-white">
          <div className=''>
            <h3 className="font-montserrat text-xl mb-2">Technology Business Incubator Foundation</h3>
            <address className="not-italic space-y-1 text-sm">
              <p>Top Floor (East Wing), M. Visvesvaraya Block</p>
              <p>Indian Institute Of Technology, Ropar</p>
              <p>Rupnagar - 140001, Punjab, India</p>
            </address>
          </div>
          <div className="mt-4 lg:mt-10">
            <h4 className="font-roboto text-lg mb-1">Contact</h4>
            <p className="text-sm">Email: <a href="mailto:tbioffice@iitrpr.ac.in" className="underline">tbioffice@iitrpr.ac.in</a></p>
            <p className="text-sm">Phone: <a href="tel:+919417484881" className="underline">+91-9417484881</a></p>
          </div>
        </div>

        {/* Right Column: Quick Links & Social */}
        <div className="flex flex-col">
          {/* Quick Links */}
          <div>
            <h4 className="text-emerald-400 font-montserrat text-lg text-center mb-3">Quick Links</h4>
            <ul className="flex flex-wrap justify-center gap-3">
              {['Home', 'About', 'Team', 'Support', 'Career', 'Contact Us'].map(label => (
                <li key={label} className="text-white font-montserrat font-bold text-sm hover:text-blue-400 transition">
                  <Link to={label === 'Home' ? '/' : `/${label.toLowerCase().replace(/\s+/g, '-')}`} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Incubate Button & Social Icons*/}
          <div className="mt-10 flex flex-col items-center">
            <a href="https://docs.google.com/forms/d/e/1FAIpQLSeonn6YOY2MH56wk2SP5XncP3WeR3BKUsXQopW6cstC63ZAuQ/viewform" target="_blank" rel="noopener noreferrer">
              <button className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-6 rounded-lg  mb-4">
                Incubate!
              </button>
            </a>
            <h4 className="font-roboto text-2xl text-white mb-2">Connect with Us</h4>
            <div className="flex space-x-6 pt-4">
                <a key={"https://www.linkedin.com/company/iit-ropar-technology-business-incubator-foundation"} href={"https://www.linkedin.com/company/iit-ropar-technology-business-incubator-foundation"} target="_blank" rel="noopener noreferrer" className="transform hover:scale-110 transition">
                  <FontAwesomeIcon icon={faLinkedin} size="2x" className="text-blue-400" />
                </a>
                <a key={"https://www.instagram.com/iitropartbif/"} href={"https://www.instagram.com/iitropartbif/"} target="_blank" rel="noopener noreferrer" className="transform hover:scale-110 transition">
                  <FontAwesomeIcon icon={faInstagram} size="2x" className="text-pink-500" />
                </a>
                <a key={"https://x.com/iitrprtbif?lang=en"} href={"https://x.com/iitrprtbif?lang=en"} target="_blank" rel="noopener noreferrer" className="transform hover:scale-110 transition">
                  <FontAwesomeIcon icon={faXTwitter} size="2x" className="text-white"/>
                </a>
                <a key={"mailto:tbioffice@iitrpr.ac.in"} href={"mailto:tbioffice@iitrpr.ac.in"} target="_blank" rel="noopener noreferrer" className="transform hover:scale-110 transition">
                  <FontAwesomeIcon icon={faGoogle} size="2x" className="text-red-500"/>
                </a>
                <a key={"https://www.facebook.com/p/IIT-Ropar-TBIF-100064188995310/"} href={"https://www.facebook.com/p/IIT-Ropar-TBIF-100064188995310/"} target="_blank" rel="noopener noreferrer" className="transform hover:scale-110 transition">
                  <FontAwesomeIcon icon={faFacebookF} size="2x" className="text-blue-600"/>
                </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
